import { render, staticRenderFns } from "./AuthorizationCode.vue?vue&type=template&id=6647eb44&"
import script from "./AuthorizationCode.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports